import { type ReactNode } from 'react'

import { type TermsMethodsKindEnum } from '@webapp/modules/purchasing/entities/enums/TermsMethodsKindEnum'
import { type TermOrMethod } from '@webapp/modules/purchasing/features/list-terms-and-methods/models'
import { TermsMethodsTable } from '@webapp/modules/purchasing/features/list-terms-and-methods/views/TermsMethodsTable'
import { useTermsMethodsListPresenter } from './useTermsMethodsListPresenter'

export interface ITermsMethodsListPresenterProps {
  kind: TermsMethodsKindEnum
  justCreatedId?: number | null
  justUpdatedId?: number | null
  onDeleteItem?: (item: TermOrMethod) => void
  renderEditableCells?: (item: TermOrMethod) => {
    name: ReactNode
    description: ReactNode
  }
}

export const TermsMethodsListPresenter = ({
  kind,
  justCreatedId,
  justUpdatedId,
  onDeleteItem,
  renderEditableCells,
}: ITermsMethodsListPresenterProps) => {
  const {
    data: { items, numPages },
    states: { page, isLoading },
    methods: { onPrevPage, onNextPage },
  } = useTermsMethodsListPresenter({ kind })

  return (
    <TermsMethodsTable
      items={items}
      justCreatedId={justCreatedId}
      justUpdatedId={justUpdatedId}
      isLoading={isLoading}
      page={page}
      numPages={numPages}
      onPrevPage={onPrevPage}
      onNextPage={onNextPage}
      onDeleteItem={onDeleteItem}
      renderEditableCells={renderEditableCells}
    />
  )
}

TermsMethodsListPresenter.displayName = 'TermsMethodsListPresenter'
